import styled from 'styled-components';

export const SubRows = styled.div`
  padding: 2px 0 2px 12px;
  border-left: 2px solid #e8edf5;
`;
export const SubRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;
  min-height: 28px;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  > * { font-size: inherit; font-weight: inherit; }
  > span:first-child { white-space: pre-wrap; overflow-wrap: anywhere; }
`;
export const SubAmount = styled.span<{ $negative?: boolean }>`
  justify-self: end;
  text-align: right;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
  color: ${({ theme, $negative }) => $negative ? (theme?.config?.text?.red || '#bc3333') : (theme?.config?.text?.primary || '#252525')};
`;
export const SubActions = styled.div`
  display: flex;
  gap: 4px;
`;

export const SubDescription = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  > span { flex: 1; white-space: pre-wrap; overflow-wrap: anywhere; }
`;

export const SubGroup = styled.div`
  > div:first-child > p { font-weight: 600; }
`;
